import Rest from '../rest'

/******************************************************************************
 *  Deal Historical
 *****************************************************************************/

/**
 * @type {DealHistorical}
 */
export default class DealHistorical extends Rest {

    constructor () {
        super('/deal/historical')
    }

    getData(url, params) {
        return this.getAll(url, params)
    }
}